import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const VolunteerDaysRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--volunteer-days']}>
    <Route index element={<Index />} />
  </SubRouter>
))
